export declare function disabledArea(dom: string | HTMLElement, flag: boolean): void;
export default disabledArea;
